module.exports = __webpack_public_path__ + "img/13.ec4f55cc.png";